/*
ローダー
------------------------------------------------------------------*/
/*
$(window).on('load', function(){
  stopload();
});
setTimeout('stopload()',10000);

function stopload(){
        $('.loading').delay(800).fadeOut(500); 
        $('.loading-bg').delay(800).fadeOut(800);
}
*/

/*
フローティングボタン
------------------------------------------------------------------*/
$(function() {
    $(window).on("scroll", function() {
        if ($(this).scrollTop() > 100) {
            $('.float-button__wrap').stop().animate({'bottom' : '0px'}, 500);
            } else {
            $('.float-button__wrap').stop().animate({'bottom' : '-200px'}, 500);
        }
    });
});